import type { Editor } from '@tiptap/core';
import type { TextRange } from '../state/viewerStore';

export interface SelectionInfo {
  /** paragraph under the caret (selection head) */
  paraId?: string;
  /** per-paragraph character ranges covered by the selection */
  ranges: TextRange[];
  /** anchor for a comment: the first paragraph's range and its quoted text */
  anchor?: { paraId: string; start: number; end: number; quote: string };
  empty: boolean;
}

/** Character offsets of the current selection per paragraph, from ProseMirror positions. */
export function selectionInfo(editor: Editor): SelectionInfo {
  const { state } = editor;
  const { from, to, $head, empty } = state.selection;
  const ranges: TextRange[] = [];
  state.doc.forEach((node, offset) => {
    if (node.type.name !== 'paragraph') return;
    const start = offset + 1;
    const end = start + node.content.size;
    if (to < start || from > end) return;
    const s = Math.max(from, start) - start;
    const e = Math.min(to, end) - start;
    const paraId = node.attrs.paraId as string | null;
    if (paraId) ranges.push({ paraId, start: s, end: e });
  });
  const headNode = $head.depth >= 1 ? $head.node(1) : undefined;
  const paraId = (headNode?.attrs.paraId as string | undefined) ?? undefined;
  const info: SelectionInfo = { paraId, ranges, empty };
  const first = ranges.find((r) => r.end > r.start);
  if (!empty && first) {
    const text = state.doc.textBetween(from, to, '\n');
    info.anchor = { paraId: first.paraId, start: first.start, end: first.end, quote: text.slice(0, 200) };
  }
  return info;
}
